import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { CarConfigStateType } from "../store";
import type { CompareSpecsType } from "../../utils/types/CompareSpecsType";

export type CarConfigCompareSpecsType = {
    initialized: boolean;
    grades: CompareSpecsType;
};

export const initialStateCarConfigCompareSpecs: CarConfigCompareSpecsType = {
    initialized: false,
    grades: [],
};

export type CarConfigCompareSpecsActionTypes = ReturnType<typeof initCarConfigCompareSpecs>;

export const CarConfigCompareSpecsSlice = createSlice({
    name: "carConfigCompareSpecs",
    initialState: initialStateCarConfigCompareSpecs,
    reducers: {
        initCarConfigCompareSpecs(state, action: PayloadAction<{ grades: CompareSpecsType }>) {
            return {
                ...state,
                ...action.payload,
                initialized: true,
            };
        },
    },
});

export const { initCarConfigCompareSpecs } = CarConfigCompareSpecsSlice.actions;

export const selectCompareSpecs = (state: CarConfigStateType): CompareSpecsType => state.carConfigCompareSpecs.grades;
